"use client"
import { Widget } from "@typeform/embed-react"
import { Fragment } from "react"
import StoryText from "../../Atoms/Storytext"

export interface TypeformSectionType {
    title: string
    typeformId: string
}

export interface TypeformSectionProps {
    data: TypeformSectionType
}

const TypeformSection: React.FC<TypeformSectionProps> = ({ data }) => {
    return (
        <div className="border-t border-black pt-12 md:pt-8">
            {data?.title && (
                <StoryText size="size3" className="mb-24 uppercase">
                    {data?.title?.split("\\n").map((part, index, array) => (
                        <Fragment key={index}>
                            {part}
                            {index < array.length - 1 && <br />}
                        </Fragment>
                    ))}
                </StoryText>
            )}
            {data?.typeformId && (
                <div className="relative overflow-hidden">
                    <Widget
                        id={data?.typeformId}
                        medium="demo-test"
                        disableScroll={true}
                        autoResize={true}
                    />
                </div>
            )}
        </div>
    )
}

export default TypeformSection
